import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureFlagService } from '../_services/feature-flag.service';

@Injectable({
	providedIn: 'root'
})
export class FeatureFlagGuardService implements CanActivate, CanActivateChild {

	constructor(
		private featureFlagService: FeatureFlagService,
		private router: Router
	) { }

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Observable<boolean> | Promise<boolean> {
		return this.checkFeatureFlag(route);
	}

	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Observable<boolean> | Promise<boolean> {
		return this.checkFeatureFlag(route);
	}

	private checkFeatureFlag(route: ActivatedRouteSnapshot): boolean {
		const featureFlag = this.getRouteDataValue(route, 'featureFlag') as string | undefined;

		if (!featureFlag) {
			return true;
		}

		const hasAccess = this.featureFlagService.hasFeatureFlag(featureFlag);

		if (!hasAccess) {
			console.log(`FeatureFlagGuardService: Access denied for feature '${featureFlag}'`);
			this.router.navigate(['/dashboard']);
			return false;
		}

		return true;
	}

	private getRouteDataValue(route: ActivatedRouteSnapshot, key: string): unknown {
		let current: ActivatedRouteSnapshot | null = route;

		while (current) {
			const value = current.data[key];
			if (value !== undefined && value !== null) {
				return value;
			}
			current = current.parent;
		}

		return undefined;
	}
}
